import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const playerEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/players?${buildAdminListQuery(params)}`,
  moderatorList: () =>
    `/admin/players?page=1&per_page=100&filters=role:moderator`,
  detail: (id: string) => `/admin/players/${id}?date=1`,
  updateRole: (playerId: string) => `/admin/players/${playerId}/role`,
  updateRoles: (playerId: string) => `/admin/players/${playerId}/roles`,
  sendNotification: (playerId: string) =>
    `/admin/players/${playerId}/notifications`,
}

export const playerBackendErrors = {
  PLAYER_NOT_FOUND: 'Oyuncu bulunamadı.',
  PLAYER_UPDATE: 'Oyuncu rolü güncellenemedi.',
  GENERAL_ERROR: 'Beklenmeyen bir hata oluştu.',
} as const

export const playerSuccessMessages = {
  playerEdit: 'Oyuncu rolleri başarıyla güncellendi!',
  sendNotification: 'Bildirim oyuncuya başarıyla gönderildi!',
}
